import { addDays, daysBetween, londonDateString } from '@geosport/shared';

function prettyDate(date: string): string {
  return new Date(`${date}T12:00:00Z`).toLocaleDateString('en-GB', {
    weekday: 'short',
    day: 'numeric',
    month: 'short',
  });
}

const Chevron = ({ dir }: { dir: 'left' | 'right' }) => (
  <svg
    aria-hidden="true"
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    {dir === 'left' ? <path d="M15 18l-6-6 6-6" /> : <path d="M9 6l6 6-6 6" />}
  </svg>
);

/** ← date → strip shared by the leaderboard and group pages. */
export function DayNav({
  date,
  onChange,
  canBack,
  canForward,
  subtitle,
}: {
  date: string;
  onChange: (date: string) => void;
  canBack: boolean;
  canForward: boolean;
  subtitle?: string;
}) {
  const age = daysBetween(date, londonDateString());
  return (
    <div className="mb-4 flex items-center justify-between rounded-2xl bg-white/5 p-2">
      <button
        type="button"
        onClick={() => onChange(addDays(date, -1))}
        disabled={!canBack}
        aria-label="Previous day"
        className="inline-flex min-h-11 min-w-11 items-center justify-center rounded-xl hover:bg-white/10 disabled:opacity-30"
      >
        <Chevron dir="left" />
      </button>
      <div className="text-center">
        <div className="font-semibold">
          {age === 0 ? 'Today' : age === 1 ? 'Yesterday' : prettyDate(date)}
        </div>
        {subtitle && <div className="text-xs text-white/50">{subtitle}</div>}
      </div>
      <button
        type="button"
        onClick={() => onChange(addDays(date, 1))}
        disabled={!canForward}
        aria-label="Next day"
        className="inline-flex min-h-11 min-w-11 items-center justify-center rounded-xl hover:bg-white/10 disabled:opacity-30"
      >
        <Chevron dir="right" />
      </button>
    </div>
  );
}
